<template>
  <div class="shares_Info">
    <div class="box1">
      <div class="box1_left">
        <div class="box1_left_top">
          <div class="box1_left_top_text1">G三峡EB1</div>
          <div class="box1_left_top_text2">132018</div>
          <div class="box1_left_top_text3">公用事业</div>
          <div class="box1_left_top_text4">电力</div>
          <div class="box1_left_top_text3">水力发电</div>
        </div>
        <div class="box1_left_bottom">
          <div class="box1_left_bottom_left">
            <div class="box1_left_bottom_left_text1"><i class="colorRed fontSize30">128.750</i> 价格</div>
            <div class="box1_left_bottom_left_text2">涨幅<i class="colorRed"> 1.52%</i></div>
          </div>
          <div class="box1_left_bottom_right">
            <div class="box1_left_bottom_right_group1">
              <div class="box1_left_bottom_right_text1">转股价值：129.33</div>
              <div class="box1_left_bottom_right_text1">溢价率：-0.09%</div>
            </div>
            <div class="box1_left_bottom_right_group1">
              <div class="box1_left_bottom_right_text1">税前收益：-7.74%</div>
              <div class="box1_left_bottom_right_text1">税后收益：-8.51%</div>
            </div>
            <div class="box1_left_bottom_right_group1">
              <div class="box1_left_bottom_right_text1">成交(万)：23775.49</div>
              <div class="box1_left_bottom_right_text1">当日换手：1.19%</div>
            </div>
          </div>
        </div>
      </div>
      <div class="box1_right">
        <div class="box1_right_top"><img style="width: 12px; height: 12px; vertical-align: middle; margin-right: 2px;" src="../../../public/img/shares_Info/add.png"/>添加自选</div>
      </div>
    </div>
    <div class="box2">
      <div class="box2_top">
        <img src="../../../public/img/income_Info/gonggao.png" alt="">公告要强赎，已发布正式赎回公告
      </div>
      <div class="box2_bottom">
        <div class="box2_bottom_text1">转债赎回最后交易日：2022年3月21日 最后转股日：2022年3月21日 赎回价：100.004元/张</div>
        <div class="box2_bottom_text1">最后交易日2022年03月21日</div>
        <div class="box2_bottom_text1">最后转股日2022年03月21日</div>
        <div class="box2_bottom_text1">转债除息2022年03月21日 每10张付息: 10.00元(含税)</div>
      </div>
    </div>

    <div class="box3">
      <div class="box3_top_title">基本资料</div>
      <Table1></Table1>
    </div>

    <div class="box4">
      <div class="box4_top_title">转股溢价率</div>
      <div class="box4_top_text">2022-03-16，转股溢价率:-0.17%</div>
      <Chart1></Chart1>
    </div>

    <div class="box5">
      <div class="box5_top_title">税前到期收益率</div>
      <div class="box5_top_text">2022-03-16，税前到期收益率:-3.31%</div>
      <Chart2></Chart2>
    </div>
    <div class="box6">
      <div class="box6_top_title">剩余份额</div>
      <div class="box6_top_text">2022-03-16，剩余份额：43.43(亿)</div>
      <Chart3></Chart3>
    </div>
    <div class="box7">
      <div class="box7_top_title">转债十大持有人</div>
      <Table2></Table2>
    </div>
    <div class="box8">
      <div class="box8_top_title">转债十大持有人</div>
      <Table3></Table3>
    </div>
  </div>
</template>

<script>
import Table1 from './table/table1.vue'
import Table2 from './table/table2.vue'
import Table3 from './table/table3.vue'
import Chart1 from './chart/chart1.vue'
import Chart2 from './chart/chart2.vue'
import Chart3 from './chart/chart3.vue'
export default {
  data() {
    return {
      
    };
  },
  methods: {
    
  },
  components: {
    Table1,
    Table2,
    Table3,
    Chart1,
    Chart2,
    Chart3,
  },
};
</script>

<style scoped>
.shares_Info {
  margin-bottom: 50px;
}
.box1 {
  width: calc(100% - 48px);
  height: 109px;
  padding: 35px 24px;
  border-radius: 3px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
}
.box1_left {
  display: flex;
  flex-direction: column;
}
.box1_left_top {
  display: flex;
  align-content: center;
  line-height: 24px;
}
.box1_left_top_text1 {
  font-size: 24px;
  font-weight: bold;
  color: #000000;
}
.box1_left_top_text2 {
  font-size: 18px;
  color: #000000;
  margin-left: 10px;
}
.box1_left_top_text3 {
  width: 64px;
  height: 20px;
  line-height: 20px;
  margin-top: 3px;
  text-align: center;
  background-color: #fcad2a;
  border-radius: 3px;
  font-size: 12px;
  color: #ffffff;
  margin-left: 18px;
}
.box1_left_top_text4 {
  width: 54px;
  height: 20px;
  line-height: 20px;
  margin-top: 3px;
  text-align: center;
  background-color: #fcad2a;
  border-radius: 3px;
  font-size: 12px;
  color: #ffffff;
  margin-left: 18px;
}
.box1_left_top_text5 {
  font-size: 12px;
  margin-left: 20px;
  color: #000000;
}
.box1_left_bottom {
  display: flex;
  margin-top: 18px;
}
.box1_left_bottom_left {
  display: flex;
  flex-direction: column;
  padding-right: 30px;
  border-right: 1px solid #ebebeb;
}
.box1_left_bottom_left_text1 {
  font-size: 18px;
	color: #999999;
}
.box1_left_bottom_left_text2 {
  font-size: 18px;
}
.box1_left_bottom_right {
  margin-left: 30px;
  display: flex;
}
.box1_left_bottom_right_group1 {
  font-size: 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-right: 30px;
  color: #333;
}
.box1_right {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  padding-left: 60px;
}
.box1_right_top {
  width: 176px;
  height: 30px;
  background-color: #fcad2a;
  border-radius: 6px;
  font-size: 12px;
  text-align: center;
  line-height: 30px;
  color: #ffffff;
  cursor: pointer;
}
.box1_right_bottom {
  display: flex;
  margin-top: 12px;
}
.box1_right_bottom_left {
  width: 84px;
  height: 30px;
  border-radius: 6px;
  border: solid 1px #fcad2a;
  font-size: 12px;
  text-align: center;
  line-height: 30px;
  color: #fcad2a;
  cursor: pointer;
}
.box1_right_bottom_right {
  width: 84px;
  height: 30px;
  border-radius: 6px;
  border: solid 1px #fcad2a;
  font-size: 12px;
  text-align: center;
  line-height: 30px;
  color: #fcad2a;
  margin-left: 6px;
  cursor: pointer;
}

i{
  font-style: normal;
}
.colorRed{
  color: #fd4c4c;
}
.colorGreen{
  color: #47BA74;
}
.colorYellow{
  color: #fcad2a;
}
.backColorRed{
  background-color: #fd4c4c;
}
.backColorGreen{
  background-color: #47BA74;
}
.backColorYellow{
  background-color: #fcad2a;
}
.fontSize30{
  font-size: 30px;
}
.box2 {
  width: calc(100% - 48px);
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  margin-top: 24px;
}
.box2_top{
  font-size: 14px;
	color: #fcad2a;
  line-height: 19px;
}
.box2_top img{
  width: 18px;
  height: 17px;
  /* line-height: 19px; */
  vertical-align: bottom;
  margin-right: 6px;
}
.box2_bottom{
  margin-top: 5px;
}
.box2_bottom_text1{
  font-size: 12px;
  line-height: 23px;
	color: #666666;
}
.box3 {
  width: calc(100% - 48px);
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  margin-top: 24px;
}
.box3_top_title{
  font-size: 18px;
  line-height: 1;
  font-weight: bold;
	color: #000000;
}
.box4 {
  width: calc(100% - 48px);
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  margin-top: 24px;
}
.box4_top_title{
  font-size: 18px;
  line-height: 1;
  font-weight: bold;
	color: #000000;
}
.box4_top_text{
  font-size: 14px;
	color: #333333;
  line-height: 1;
  margin-top: 24px;
}
.box5 {
  width: calc(100% - 48px);
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  margin-top: 24px;
}
.box5_top_title{
  font-size: 18px;
  line-height: 1;
  font-weight: bold;
	color: #000000;
}
.box5_top_text{
  font-size: 14px;
	color: #333333;
  line-height: 1;
  margin-top: 24px;
}
.box6 {
  width: calc(100% - 48px);
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  margin-top: 24px;
}
.box6_top_title{
  font-size: 18px;
  line-height: 1;
  font-weight: bold;
	color: #000000;
}
.box6_top_text{
  font-size: 14px;
	color: #333333;
  line-height: 1;
  margin-top: 24px;
}
.box7 {
  width: calc(100% - 48px);
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  margin-top: 24px;
}
.box7_top_title{
  font-size: 18px;
  line-height: 1;
  font-weight: bold;
	color: #000000;
}
.box8 {
  width: calc(100% - 48px);
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  margin-top: 24px;
}
.box8_top_title{
  font-size: 18px;
  line-height: 1;
  font-weight: bold;
	color: #000000;
}
</style>